import { render, staticRenderFns } from "./EditFormAnouncement.vue?vue&type=template&id=79e4f620&lang=pug"
import script from "./EditFormAnouncement.vue?vue&type=script&lang=js"
export * from "./EditFormAnouncement.vue?vue&type=script&lang=js"
import style0 from "./EditFormAnouncement.vue?vue&type=style&index=0&id=79e4f620&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports